// Settings → Security → Overview: the health card's small words (DESIGN-security.md, step 2).
// Pure — `securityHealth.checks.mjs` pins them. ⚠️ NO REACT AND NO IMPORTS: the checks import
// this file under plain node.
//
// The lists themselves (who, and why) come from the server (`services/security_health.py`);
// this only says "invited yesterday", "last signed in 02/06/2026" and so on.

const DAY = 86400000;
const pad = (n) => String(n).padStart(2, '0');

function ukDate(ms) {
  const d = new Date(ms);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** Whole calendar days between two moments, on this browser's clock (0 = same day). */
export function daysBetween(fromMs, toMs) {
  const a = new Date(fromMs); a.setHours(12, 0, 0, 0);
  const b = new Date(toMs); b.setHours(12, 0, 0, 0);
  return Math.round((b - a) / DAY);
}

/** Rob's addition to 3A: "invited yesterday", "invited 3 weeks ago — that link has run out". */
export function invitedWords(invitedIso, expired, nowMs = Date.now()) {
  const at = Date.parse(invitedIso || '');
  if (!Number.isFinite(at)) return 'never invited';
  const days = daysBetween(at, nowMs);
  let when;
  if (days <= 0) when = 'invited today';
  else if (days === 1) when = 'invited yesterday';
  else if (days < 14) when = `invited ${days} days ago`;
  else if (days < 60) when = `invited ${Math.floor(days / 7)} weeks ago`;
  else when = `invited on ${ukDate(at)}`;
  return expired ? `${when} — that link has run out` : when;
}

/** The button for somebody who has never signed in: a first invitation, or another one. */
export function inviteButton(invitedIso) {
  return invitedIso ? 'Send again' : 'Send invite';
}

/** "last signed in 02/06/2026" */
export function lastSignedInWords(iso) {
  const at = Date.parse(iso || '');
  return Number.isFinite(at) ? `last signed in ${ukDate(at)}` : '';
}

/** "Reminded today" / "Reminded yesterday" / "Reminded 25/10/2026" — or '' if never. */
export function remindedWords(iso, nowMs = Date.now()) {
  const at = Date.parse(iso || '');
  if (!Number.isFinite(at)) return '';
  const days = daysBetween(at, nowMs);
  if (days <= 0) return 'Reminded today';
  if (days === 1) return 'Reminded yesterday';
  return `Reminded ${ukDate(at)}`;
}

/** "locked until 14:17" */
export function lockedUntilWords(iso) {
  const at = Date.parse(iso || '');
  if (!Number.isFinite(at)) return '';
  const d = new Date(at);
  return `locked until ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** "Tue 20/10 at 14:02" — a lockout in the last week. */
export function lockoutWhen(iso) {
  const at = Date.parse(iso || '');
  if (!Number.isFinite(at)) return '';
  const d = new Date(at);
  const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()];
  return `${day} ${pad(d.getDate())}/${pad(d.getMonth() + 1)} at ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** "1 person" / "3 people" */
export function people(n) {
  return n === 1 ? '1 person' : `${n} people`;
}

/** The chip in the card's corner: "3 things to look at", "1 thing to look at", or null. */
export function lookAtWords(n) {
  if (!n) return null;
  return n === 1 ? '1 thing to look at' : `${n} things to look at`;
}
